import { useTranslation } from 'react-i18next';
import { HideIcon, ShowIcon } from '../../bombiix-icon';
import type { TitleVisibilityButtonProps } from './title-visibility-button.types';

/**
 * Eye toggle that sets whether a section or sub-section title is shown on the rendered form.
 * @param isShown - Whether the title is shown.
 * @param onChange - Receives the new state.
 * @returns The toggle button.
 */
function TitleVisibilityButton({ isShown, onChange }: TitleVisibilityButtonProps) {
  const { t } = useTranslation('custom-module-system-canvas');
  const label = isShown ? t('COMMON.HIDE') : t('COMMON.SHOW');

  return (
    <button type="button" className="cm-inline-library__button cm-title-visibility" aria-label={label} title={label} aria-pressed={!isShown} onClick={() => onChange(!isShown)}>
      {isShown ? <ShowIcon size={TITLE_VISIBILITY_ICON_SIZE} /> : <HideIcon size={TITLE_VISIBILITY_ICON_SIZE} />}
    </button>
  );
}

export default TitleVisibilityButton;

const TITLE_VISIBILITY_ICON_SIZE = 20;
